import React, { useContext, useState } from "react";
import SolitaireContext from "../../context/solitaireContext";
import tertiaryPNG from "../../assets/spider-color-tertiary-no-stroke.png";

const Start = () => {
  const solitaireContext = useContext(SolitaireContext);
  const { setStarted } = solitaireContext;

  const [startToggled, setStartToggled] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className="start">
      <div className={startToggled ? "container started" : "container"}>
        <h1 className="title">
          Добро пожаловать в<br/> <span>«Паук солитер»</span>
        </h1>
        <div className="info">
          <p>
            Если вы знакомы с пасьянсом «Паук», вы сможете в мгновение ока
            освоить пасьянс «Паук солитер»
          </p>
          
                  </div>
        <button className="play-btn" style={{marginBottom:'5px'}}  onClick={() => setModalOpen(true)}>
            Показать правила
          </button>
        <button
          
          onClick={() => {
            setStartToggled(true);

            setTimeout(() => {
              setStarted(true);
            }, 2000);
          }}

          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "40px", // Установите ширину кнопки
            height: "40px", // Установите высоту кнопки
            padding:"2px",
            borderRadius: "50%", // Сделайте кнопку круглой
            border: "none",
            cursor: "pointer",
           
           
           
                                   
          }}
        >
        <svg
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-hidden="true"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="currentColor"
  stroke="#851939"
  strokeWidth={3}
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M5 3l14 9-14 9V3z"
  />
</svg>

        </button>
        <div className="spider">
          <img src={tertiaryPNG} alt="Loading" />
        </div>
      </div>

      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Правила</h2>
            <ul>
              <li>
                🕷️ Чтобы переместить карты, сначала нажмите на карту или карты,
                затем нажмите на карту назначения
              </li>
              <li>
                🕷️ Нажмите на нижнюю карту любой стопки, чтобы отменить выбор
                карт.
              </li>
              <li>🕷️ Отсортируйте карты от «Туза» до «Короля».</li>
              <li>🕷️ Нельзя нажимать на закрытые карты.</li>
              <li>
                🕷️ Вы не можете добавлять карты из колоды, если есть пустая
                колода.
              </li>
              <li>🕷️ Вы получите 125 баллов за каждый забег от «А» до «К».</li>
              <li>🕷️ Попробуйте стать самым быстрым игроком в «Паук солитер».</li>
            </ul>
            <button className="close-btn" onClick={() => setModalOpen(false)}>
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Start;
